import { HStack, VStack, XScroll } from "IZOX/_X";
import { LogicX } from "IZOX/STATIC";
import React, { Children, cloneElement, useRef } from "react";

/**
 * 
 * @typedef {Object} scrollsyncparam 
 * @property {Number | String} height 
 * @property {"V" | "H"} [direction="V"] 
 * @property {*} children 
 * 
 * @param {scrollsyncparam}  param0
 * @returns 
 */
function ScrollSync({
  direction = "V",
  children,
  ...others
}){

  const ref = useRef([]);

  const onScroll = (e) => {
    for(const o of ref.current){
      switch(direction){
        default: case "V":
          o.scrollTop = e.target.scrollTop; break;
        case "H": {
          o.scrollLeft = e.target.scrollLeft; break;
        }
      }
      
    }
  };

  function renderChildren(_c){
    return Children.map(_c, (o, i) => {
      if (!React.isValidElement(o)) return o;
      let addOns = {};
      if(LogicX.isOneOf(o.type, [XScroll])){
        addOns = {
          ...addOns,
          forwardRef: e => ref.current[i] = e,
          onScroll: onScroll
        };
      }
      return cloneElement(o, addOns);
    });
  };

  switch(direction){
    default: case "V":
      return (
        <HStack {...others}>
          {renderChildren(children)}
        </HStack>
      ); 
    case "H": {
      return (
        <VStack {...others}>
          {renderChildren(children)}
        </VStack>
      );
    }
  }
  

}

export default ScrollSync;